module.exports = __webpack_public_path__ + "static/media/c9.7ad848a6.jpg";